import axios from 'axios';
import { msalInstance } from '../index';
import { apiRequest, API_BASE_URL } from '../authConfig';

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset-utf-8',
  },
});

instance.interceptors.request.use(async (config) => {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!account) return config;

  try {
    const { accessToken } = await msalInstance.acquireTokenSilent({
      scopes: apiRequest.scopes,
      account,
    });

    if (accessToken) {
      config.headers = { ...(config.headers || {}), Authorization: `Bearer ${accessToken}` };
    }
  } catch (error) {
    console.warn('acquireTokenSilent failed in interceptor', error);
  }

  return config;
});

export default function createAPI() {
  return instance;
}